import { Component, DOCUMENT, Inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-beauty-salon-booking-challenges',
  imports: [TranslateModule],
  templateUrl: './beauty-salon-booking-challenges.component.html',
  styleUrl: './beauty-salon-booking-challenges.component.scss',
})
export class BeautySalonBookingChallengesComponent implements OnInit {
  constructor(
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {}
}
